<div class="plp-mobile-menu" [ngClass]="{ visible: isVisible }">
  <div class="mobile-menu-title-div">
    <span class="mobile-menu-title">{{ 'FILTER' | translate }}</span>
    <span class="mobile-menu-close-btn" (click)="toggle()">×</span>
  </div>

  <div class="mobile-menu-options filters-sections col">
    <tvb-filters-section [initExpanded]="false"></tvb-filters-section>
  </div>

  <div class="mobile-menu-bottom-bar">
    <div class="clear-filters-btn-div-mobile">
      <a id="clear-filters-btn-mobile" class="tvb-link" (click)="emitClear($event)">
        {{ 'Clear Filter' | translate }}
      </a>
    </div>

    <div class="apply-btn-div">
      <button id="apply-btn-mobile" class="btn btn-primary" (click)="emitApply($event)">
        {{ 'Apply' | translate }} ({{ totalItemsCount }})
      </button>
    </div>
  </div>
</div>
